export function LogoMark({ className = "w-8 h-8" }) {
  return (
    <img
      src="/brand/cr-mark-v2.png"
      alt="Conexa Relay"
      draggable={false}
      className={`object-contain select-none ${className}`}
    />
  );
}

// Full brand lockup image (CR mark + "CONEXA RELAY" in the brand display font).
// variant="auto" swaps a dark-surface (white CONEXA) vs light-surface (navy CONEXA)
// version based on the theme; variant="dark" forces the white version (dark backgrounds).
export function Wordmark({ className = "", sizeClass = "h-7", variant = "auto" }) {
  const base = `object-contain select-none w-auto ${sizeClass} ${className}`;
  if (variant === "dark") {
    return <img src="/brand/wordmark.png" alt="Conexa Relay" draggable={false} className={base} />;
  }
  return (
    <>
      <img src="/brand/wordmark.png" alt="Conexa Relay" draggable={false} className={`hidden dark:block ${base}`} />
      <img src="/brand/wordmark-light.png" alt="Conexa Relay" draggable={false} className={`block dark:hidden ${base}`} />
    </>
  );
}
